import React from 'react';
import { node, string } from 'prop-types';

import styles from './GridRow.scss';

export default function GridRow({ title, children }) {
  const childrenArray = React.Children.toArray(children);
  return (
    <div className={styles.main}>
      <div className={styles.titleContainer}>
        <h3 className={styles.title}>
          {title}
        </h3>
      </div>
      <div className={styles.childrenContainer}>
        {childrenArray.map(child =>
          <div key={child.props.label} className={styles.item}>
            {child}
          </div>
        )}
      </div>
    </div>
  );
}

GridRow.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/GridRow/index.js